import { format } from 'date-fns';
import { AXIS_MASTER_LABEL_DATE_FORMAT, WHITE_COLOR, PAGE_BG_COLOR, GRID_LINE_COLOR, CHART_SELECTED_PERIOD_COLOR, YEAR_INTERVAL, COLORS, } from '../constants';
export const getDefaultMasterChartOptions = ({ apiData, setDetailChartData, setShowReset, }) => ({
    chart: {
        height: 150,
        reflow: false,
        borderWidth: 0,
        backgroundColor: PAGE_BG_COLOR,
        plotBorderColor: GRID_LINE_COLOR,
        plotBorderWidth: 1,
        marginRight: 10,
        marginLeft: 65,
        zoomType: 'x',
        resetZoomButton: {
            relativeTo: 'spacingBox',
        },
        events: {
            selection(event) {
                const { series } = this;
                const extremesObject = event.xAxis[0];
                const { min, max } = extremesObject;
                const detailData = [];
                const xAxis = this.xAxis[0];
                series.forEach(({ data, name }) => {
                    const outputData = [];
                    data.forEach((innerData) => {
                        if (innerData.x > min && innerData.x < max) {
                            outputData.push([innerData.x, Number(innerData.y)]);
                        }
                    });
                    detailData.push({
                        name,
                        data: outputData,
                    });
                });
                // move the plot bands to reflect the new detail span
                xAxis.removePlotBand('mask-before');
                xAxis.addPlotBand({
                    id: 'mask-before',
                    from: max,
                    to: min,
                    color: CHART_SELECTED_PERIOD_COLOR,
                });
                xAxis.removePlotBand('mask-after');
                xAxis.addPlotBand({
                    id: 'mask-after',
                    from: max,
                    to: min,
                    color: CHART_SELECTED_PERIOD_COLOR,
                });
                setShowReset(true);
                setDetailChartData(detailData);
                return false;
            },
        },
    },
    title: {
        text: undefined,
    },
    accessibility: {
        enabled: false,
    },
    xAxis: {
        min: null,
        max: null,
        tickColor: 'none',
        lineColor: 'none',
        type: 'datetime',
        tickInterval: YEAR_INTERVAL,
        labels: {
            style: { color: WHITE_COLOR, opacity: 0.7 },
            formatter: (item) => format(new Date(item.value), AXIS_MASTER_LABEL_DATE_FORMAT),
        },
        title: {
            text: undefined,
        },
    },
    yAxis: {
        gridLineWidth: 0,
        title: {
            text: null,
        },
    },
    tooltip: {
        formatter: () => false,
    },
    legend: {
        enabled: true,
        itemDistance: 30,
        itemHiddenStyle: {
            color: 'rgba(69, 77, 85, 0.25)',
        },
        itemHoverStyle: undefined,
        itemStyle: { color: WHITE_COLOR },
    },
    credits: {
        enabled: false,
    },
    plotOptions: {
        series: {
            lineWidth: 1,
            marker: {
                enabled: false,
            },
            shadow: false,
            states: {
                hover: {
                    lineWidth: 1,
                },
            },
            enableMouseTracking: false,
        },
    },
    colors: COLORS,
    series: apiData.map(({ data, name }) => ({
        type: 'line',
        name,
        pointInterval: 24 * 3600 * 1000,
        pointStart: data[0][0],
        data,
        borderColor: GRID_LINE_COLOR,
    })),
    exporting: {
        enabled: false,
    },
});
//# sourceMappingURL=getDefaultMasterChartOptions.js.map